import {
  DEVICE_LIST_REQUEST, DEVICE_LIST_SUCCESS, DEVICE_LIST_FAILURE,
  REMOVE_DEVICE_SUCCESS
} from '../actions/devices'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'

const INITIAL_STATE = {
  lastRetrieved: -1,
  isLoading: false,
  hasError: false,
  errorMessage: '',
  devices: []
}

const devicesReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
      return {
        ...INITIAL_STATE
      }

    case DEVICE_LIST_REQUEST:
      return {
        ...state,
        lastRetrieved: -1,
        isLoading: true,
        hasError: false,
        errorMessage: ''
      }
    case DEVICE_LIST_SUCCESS:
      return {
        ...state,
        lastRetrieved: Date.now(),
        isLoading: false,
        devices: action.payload
      }
    case DEVICE_LIST_FAILURE:
      return {
        ...state,
        lastRetrieved: Date.now(),
        isLoading: false,
        hasError: true,
        errorMessage: action.payload.message
      }
    case REMOVE_DEVICE_SUCCESS:
      return {
        ...state,
        lastRetrieved: -1,
        isLoading: false,
        devices: []
      }
    default:
      return state
  }
}

export default devicesReducer
